import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IDatabaseItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/types/IDatabaseItemResponseInstance'

export function mapDatabaseItemResponseInstance(databaseItem: IToJson<IDatabaseItemResponseInstance>): IDatabaseItemResponseInstance {
  return {
    ...databaseItem,
    createdAt: new Date(databaseItem.createdAt),
  }
}
